/**
 * Helper mixin for form validation
 */
const formValidationMixin = {
  methods: {
    /**
     * Return input state
     * null: no state
     * true: valid state (green)
     * false: invalid state (red)
     *
     * @param validation
     * @returns {*}
     */
    inputState(validation) {
      // not dirty state
      if (!validation.$dirty) {
        return null;
      }

      // if empty dont show valid status
      if (!validation.$error && !validation.$model) {
        return null;
      }

      return !validation.$error;
    },
  },
};

export { formValidationMixin };
